import sanitizeHtml from 'sanitize-html';
const allowedTags = sanitizeHtml.defaults.allowedTags.concat(['img']);
const allowedAttributes = Object.assign({}, sanitizeHtml.defaults.allowedAttributes, {
    img: ['src', 'alt', 'title', 'width', 'height'],
    a: ['href', 'name', 'target', 'rel', 'aria-label'],
});
export const sanitizeHTML = (value) => {
    return sanitizeHtml(value, {
        allowedTags,
        allowedAttributes,
    });
};
